// src/data/mockPrograms.js
const MOCK_PROGRAMS = [
    {
        id: 'mock-1',
        name: 'The 5 to 20 Method',
        description: 'Build your movement habit from 5 minutes a day to a full 20-minute routine. Perfect for beginners and busy schedules.',
        price: 49.99,
        priceLabel: '$49.99',
        bunnyCollectionId: '',
        facebookGroupUrl: '',
        imageEmoji: '',
        highlights: ['4-week progressive program', 'Videos from 5 to 20 minutes', 'Upper, lower & core workouts', 'Private Facebook community'],
        details: 'The 5 to 20 Method is designed for women who want to build a consistent movement habit without the overwhelm. Start with just 5 minutes a day and gradually build up to 20 minutes over 4 weeks.',
        order: 1,
        active: true,
    },
    {
        id: 'mock-2',
        name: 'Core Foundations',
        description: 'Strengthen your core from the inside out with targeted exercises designed for every fitness level.',
        price: 39.99,
        priceLabel: '$39.99',
        bunnyCollectionId: '',
        facebookGroupUrl: '',
        imageEmoji: '',
        highlights: ['3-week core program', 'Progressive difficulty', 'Postpartum friendly', 'Video guides included'],
        details: 'Core Foundations focuses on building real core strength — not just abs. Includes pelvic floor work, deep core activation, and functional movement patterns.',
        order: 2,
        active: true,
    },
];
export default MOCK_PROGRAMS;